import { useEffect } from 'react';

/** Canonical site origin for meta tags and sitemap alignment */
export const SITE_ORIGIN = 'https://www.leadlegale.com';

/** Shared keyword set for Italian legal / traffic accident SEO */
export const SEO_KEYWORDS_PRIMARY =
  'infortunistica stradale, risarcimento danni, consulenza legale, incidente stradale, sinistro stradale, danni da incidente, assistenza legale sinistri, avvocato infortunistica, richiesta risarcimento, malasanità, Lead Legale';

function upsertMetaByName(name, content) {
  if (content == null || content === '') return;
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('name', name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', String(content));
}

function upsertMetaByProperty(property, content) {
  if (content == null || content === '') return;
  let el = document.querySelector(`meta[property="${property}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('property', property);
    document.head.appendChild(el);
  }
  el.setAttribute('content', String(content));
}

function upsertLinkRel(rel, href) {
  if (!href) return;
  let el = document.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

/**
 * Updates document title, description, keywords, canonical, Open Graph and robots.
 * Safe for SPA route changes (no extra dependencies).
 */
export function applyDocumentSeo({
  title,
  description,
  keywords,
  path = '/',
  noindex = false,
  ogImage = `${SITE_ORIGIN}/favicon.png`,
}) {
  if (typeof document === 'undefined') return;

  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  const canonical = `${SITE_ORIGIN}${normalizedPath}`;

  document.title = title;
  upsertMetaByName('description', description);
  upsertMetaByName('keywords', keywords || SEO_KEYWORDS_PRIMARY);
  upsertLinkRel('canonical', canonical);

  upsertMetaByProperty('og:title', title);
  upsertMetaByProperty('og:description', description);
  upsertMetaByProperty('og:url', canonical);
  upsertMetaByProperty('og:type', 'website');
  if (ogImage) upsertMetaByProperty('og:image', ogImage);

  upsertMetaByName('twitter:card', 'summary_large_image');
  upsertMetaByName('twitter:title', title);
  upsertMetaByName('twitter:description', description);

  upsertMetaByName('robots', noindex ? 'noindex, nofollow' : 'index, follow');
}

/**
 * Declarative SEO for React pages (runs in useEffect).
 */
export function SeoHead({ title, description, keywords, path = '/', noindex = false, ogImage }) {
  useEffect(() => {
    applyDocumentSeo({ title, description, keywords, path, noindex, ogImage });
  }, [title, description, keywords, path, noindex, ogImage]);
  return null;
}
